import BaseSensorExtension from '../base-sensor';
import formatMessage from 'format-message';

class LEDActuatorExtension extends BaseSensorExtension {
    constructor (runtime) {
        super(runtime);
    }

    getSensorInfo () {
        return {
            id: 'ledActuator',
            name: 'LED',
            color1: '#D32F2F',
            color2: '#C62828',
            color3: '#B71C1C',

            blocks: [
                {
                    opcode: 'led_setDigital',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'ledActuator.blocks.turn',
                        default: 'turn LED on pin [PIN] [STATE]'
                    }),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '13',
                            menu: 'digitalPinMenu'
                        },
                        STATE: {
                            type: 'string',
                            defaultValue: 'HIGH',
                            menu: 'highLowMenu'
                        }
                    }
                },
                {
                    opcode: 'led_setPWM',
                    blockType: 'command',
                    text: formatMessage({
                        id: 'ledActuator.blocks.setPwm',
                        default: 'set LED PWM on pin [PIN] to [PWM]'
                    }),
                    arguments: {
                        PIN: {
                            type: 'number',
                            defaultValue: '5',
                            menu: 'digitalPinMenu'
                        },
                        PWM: {
                            type: 'number',
                            defaultValue: '128'
                        }
                    }
                }
            ],

            menus: {},

            codeTemplates: [
                {
                    opcode: 'led_setDigital',
                    type: 'command',
                    arduino: {
                        code: 'digitalWrite({{PIN}}, {{STATE}});',
                        setup: ['pinMode({{PIN}}, OUTPUT);'],
                        includes: []
                    },
                    python: {
                        code: 'pin_{{PIN}}.value(1 if "{{STATE}}" == "HIGH" else 0)',
                        setup: ['pin_{{PIN}} = Pin({{PIN}}, Pin.OUT)'],
                        imports: ['from machine import Pin']
                    }
                },
                {
                    opcode: 'led_setPWM',
                    type: 'command',
                    arduino: {
                        code: 'analogWrite({{PIN}}, {{PWM}});',
                        setup: ['pinMode({{PIN}}, OUTPUT);'],
                        includes: []
                    },
                    python: {
                        code: 'pwm_{{PIN}}.duty_u16(int(({{PWM}} / 255.0) * 65535))',
                        setup: [
                            'pwm_{{PIN}} = PWM(Pin({{PIN}}))',
                            'pwm_{{PIN}}.freq(1000)'
                        ],
                        imports: ['from machine import Pin, PWM']
                    }
                }
            ]
        };
    }

    led_setDigital (args) {
        return Promise.resolve();
    }

    led_setPWM (args) {
        return Promise.resolve();
    }
}

export default LEDActuatorExtension;
